var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cz2__modal-popup is-kiosk cz2__printing-progress"},[_c('focus-lock',[_c('red-banner-button',{attrs:{"as":"div"}},[_vm._v(" "+_vm._s(_vm.$t('PRINTING'))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }